import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'react-feather';
import Card from '../UI/Card';
import useTranslation from '../../hooks/useTranslation';

const ToolCard = ({ tool, toolKey, category }) => {
  const IconComponent = tool.icon;
  const { t } = useTranslation();

  return (
    <Link to={`/tools/${category}/${toolKey}`}>
      <Card className="p-6 h-full">
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0">
            <div className="p-3 bg-primary-100 dark:bg-primary-900/30 rounded-lg">
              <IconComponent className="h-6 w-6 text-primary-600 dark:text-primary-400" />
            </div>
          </div>

          <div className="flex-grow">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
              {t(`tool.name.${toolKey}`, tool.name)}
            </h3>
            <p className="text-gray-600 dark:text-gray-400 text-sm mb-4">
              {t(`tool.desc.${toolKey}`, tool.description)}
            </p>

            <div className="flex items-center text-primary-600 dark:text-primary-400 text-sm font-medium group">
              <span>{t('tool.common.useTool')}</span>
              <ArrowRight className="h-4 w-4 ml-2 transform group-hover:translate-x-1 transition-transform duration-200" />
            </div>
          </div>
        </div>
      </Card>
    </Link>
  );
};

export default ToolCard;
